export const da = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Tilføj tekst',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Føj til vognen',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Juster bunden',
  ALIGN_CENTER_KEY: 'justere center',
  ALIGN_KEY: 'tilpasse',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'juster midten',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Juster toppen',
  ALL_TAB_TITLE_KEY: 'Alle',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Baggrund',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Ingen inspiration fundet under denne kategori',
  BRING_TO_FRONT_KEY: 'Bring foran',
  CANCEL_TEXT_KEY: 'Annuller',
  CENTIMETERS_KEY: 'centimeter',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Vælg fil',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Ryd alle',
  CLEAR_COLOR_KEY: 'Ryd farve',
  CLOSE_WINDOW_KEY: 'Luk vindue',
  CLEAR_ALL_OBJECTS: 'Ryd alle projekter',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Dette vil fjerne alle objekter fra din baggrund.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Farve',
  CONTINUE_KEY: 'Fortsæt...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Design',
  DELETE_KEY: 'Slet',
  DOCUMENT_COLORS: 'Dokumentfarver',
  DONE: 'Done!',
  DONE_KEY: 'Udført',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Hent',
  DOWNLOAD_APP_TITLE_KEY: 'Du kan downloade appen her:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox-import',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime søgning',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime billeder',
  DUPLICATE_KEY: 'Duplikat',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Rediger design',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Vi beklager, men der opstod en fejl. Prøv igen senere.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Hovsa, der opstod en fejl ved åbning af den uploadede PDF-fil.',
  EMAIL_KEY: 'E-mail',
  EMAIL_ADDRESS_KEY: 'E-mailadresse:',
  EMAIL_CHECKBOX_MESSAGE:
    'Jeg ved, at denne persion er indforstået med, at vedkommende vil modtage e-mailbeskeder fra HP på mine eller denne tjenesteudbyders vegne.',
  EXTRA_INFO_KEY: 'Yderligere oplysninger',
  EMAIL_NOTIFICATION:
    'En e-mail vil blive sent om et øjeblik. Giv os 15 minutter til at behandle det.',
  EMAIL_DIALOG_MESSAGE:
    'Indtast e-mailadressen for den person, du ønsker at dele dit design med.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Allerede oprettet mappe',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Kontrollér, at alle de valgte varer er korrekte, før du betaler',
  FINAL_CHECK_TITLE_KEY: 'Sidste kontrol',
  FINISH_KEY: 'Udfør',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Vend',
  FOR_KEY: 'til',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Nøgleord:',
  FOLDER_NAME: 'Mappenavn',
  FOLDER_NAME_KEY: 'Mappenavn:',
  FOLDER_ALREADY_EXIST_KEY: 'Dette mappenavn findes allerede',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Grupper alle',
  GROUP_SCALE: 'Gruppeskala',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Giv et navn til dit projekt',
  HEIGHT_KEY: 'Højde',
  HELP_DESCRIPTION_KEY:
    'Let us walk you through the design process. Remember you can open the tour as many times as you want by clicking on the help icon.',
  HELP_KEY: 'Hjælp',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'BILLEDER',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importerer',
  INCHES_COLUMN_HEADER_KEY: 'Tommer',
  INCHES_KEY: ' tommer',
  INCHES_UNIT_STRING_KEY: 'in.',
  INVALID_EMAIL_ADDRESS_KEY: 'Ugyldig e-mailadresse',
  INVALID_INFO_KEY: 'Angiv detaljer.',
  INVALID_NAME_KEY: 'Ugyldigt navn',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Undskyld, men den fil, du har valgt, er for stor. Den maksimale filstørrelse er 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Hovsa, dette er ikke et gyldigt filformat. Vi kan kun håndtere pdf, jpg, png, svg og tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Sprog',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Flere oplysninger',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Ved at bruge dette websted accepterer du at være bundet af disse',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Dette websted overholder',
  LEGAL_FOOTER_MESSAGE3_KEY: 'og',
  LENGTH_STRING_IN_INCHES_KEY: 'in',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Hvis du vil visualisere det digitale indhold, skal du downloade appen LinkReader.',
  LOADING_KEY: 'Indlæser...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Lås',
  LOGIN_KEY: 'Log på',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Log ind på Dreamstime ',
  LOGOUT_KEY: 'Log af',
  MATERIAL_TITLE_KEY: 'MATERIALE',
  MATERIAL_STRING_KEY: 'Materiale',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Denne baggrund kan ikke nedskaleres mere, fordi du har nået minimumshøjden eller -bredden, som kræves til at dække din væg.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Model',
  MORE_INFO_TEXT_KEY: 'Flere oplysninger',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Navn:',
  NEXT_BUTTON_TITLE_KEY: 'NÆSTE',
  NEW_FOLDER_KEY: 'Ny mappe',
  NO_SHADOW_KEY: 'Ingen skygge',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Bestil prøve',
  ORDER_SAMPLE: 'Bestil en prøve',
  ORDER_SAMPLE_INFOLABEL_1:
    'Vælg den del af billedet, du vil bestille som en prøve',
  ORDER_SAMPLE_INFOLABEL_2:
    'Du vil modtage en e-mail med en nærvisning af dit projekt i den aktuelle størrelse',
  ORDER_SAMPLE_INFOLABEL_3:
    'Det er en hjælp til at evaluere kvaliteten og opløsningen',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Bestil prøve nu',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Modtag en e-mail, der indeholder en nærvisning af dit projekt på den aktuelle størrelse for at evaluere kvaliteten/opløsningen.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Adgangskode',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Jeg ejer copyrighten for dette billede og accepterer at',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY: 'Dvs. vigtige oplysninger til printshoppen',
  PLACEHOLDER_INCHES_STRING_KEY: 'in',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Position',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Gem dit projekt',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Dit projekt har ændringer, som skal gemmes, inden du fortsætter.',
  PRICE_COLUMN_HEADER_KEY: 'Pris',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Behandler...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Forudvisning',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Projektnavn',
  PROJECT_NAME: 'Projektnavn:',
  PROJECT_ALREADY_EXIST_KEY: 'Dette projektnavn findes allerede',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Dette projektnavn findes allerede',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Dette mappenavn findes allerede',
  PIXELATION_WARNING_KEY: 'Advarsel om pixelering',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'På grund af opløsningen af ​​dit uploadede foto kan din hud blive forvrænget eller forvrænget. For at sikre, at der ikke er sløring, skal du uploade et billede af god kvalitet og undgå billedstrækning. Hvis du er tilfreds med forhåndsvisningen og gerne vil fortsætte, skal du fortsætte med at indsende.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: 'Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'PÅKRÆVET',
  RECOLOR_KEY: 'Omfarvelæg',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Omfarvelæg',
  REQUEST_SAMPLE_KEY: 'Anmod om en prøve',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Anmodning om et tilbud',
  RIGHT_LOGO_TEXT_KEY: 'af',
  ROTATE_KEY: 'Roter',
  ROTATE_LEFT_KEY: 'Roter 90° til venstre',
  ROTATE_RIGHT_KEY: 'Roter 90° til højre',
  ROTATION_KEY: 'Rotation',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Rækker og kolonner',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Gem',
  SAVING_KEY: 'Gemmer...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Gem dit projekt',
  SAVE_PROJECT_NAME_KEY: 'Gem dit projekt først',
  SAVEDIALOG_MESSAGE:
    'Log på for at gemme dit projekt. Hvis du ikke har en konto, vil vi hjælpe dig med at oprette en. Dit fremskridt vil ikke gå tabt.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Skaler',
  SCALE_ALL_KEY: 'Skaler alle',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Søg',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Søg',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Send mig anvisninger på installation',
  SEND_TO_BACK_KEY: 'Send bagved',
  SEND_KEY: 'Send',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Angiv størrelse',
  SETTINGS_KEY: 'Indstillinger',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Del',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'kvadratfod',
  SQM_UNIT_STRING_KEY: 'kvadratmeter',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Indsend',
  SHARE_LINK_LABEL: 'Vælg den type link, du ønsker at dele',
  SHARE_EDIT_LINK: 'Rediger link',
  SHARE_VIEW_LINK: 'Se link',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT:
    '* Den ønskede afstand for visning kan ændres i indstillingerne.',
  TERMS1_KEY: 'betingelser',
  TERMS2_KEY: "HP's erklæring om personlige oplysninger",
  TERMS3_KEY:
    "HP's bekendtgørelse om rettigheder i forbindelse med personlige data",
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Vilkår for brug.',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Flise',
  TOTAL_KEY: 'I ALT',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Tak',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Oplås',
  UNGROUP_KEY: 'Afgruppér',
  UPDATE_TEXT_KEY: 'Opdater',
  UPLOAD_KEY: 'Billedupload',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Brugernavn',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Fjern fliser',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Gyldighed',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'Moms',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Se i Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Vis designdetaljerne',
  VIEW_DESIGNER_PROFILE_KEY: 'Vis designerprofilen',
  VIEW_PRICE_KEY: 'Se pris',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Vægplakat',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Advarsel',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Bredde',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Dit navn',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Dit projekt:',
  PROJECT_NAME_ERROR_TEXT: 'Indtast et navn for dit projekt.',
  PROJECT_FOLDER_ERROR_TEXT: 'Indtast et navn for din projektmappe.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Minimumsafstand for visning',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Ingen Indhold fundet',
  NO_ELEMENT_ERROR_MESSAGE: 'Der blev ikke fundet noget element.',
  NO_MORE_IMAGES_FOUND_KEY: 'Der blev ikke fundet flere billeder',
  NO_PATTERN_ERROR_MESSAGE: 'Der blev ikke fundet nogen mønstre.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',

  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Meddelelse:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will recieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Du har skaleret til et punkt, hvor dit udskrevne billede kan se pixelleret ud, når man ser det fra en afstand på {0} {1} * (aktuel udskrevet opløsning er {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Den anbefalede visningsafstand ville være {0} {1}. Hvis denne ikke er rigtig, reducer skalaen på dette billede eller størrelsen på din vægkunst.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Den anbefalede billedstørrelse er mindst {0} x {1} pixel.',
  UPLOAD_STATUS: '{0}% of {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Minimumsdimensioner er {0} (b) og {1} (h).',
  MINIMUM_HEIGHT_KEY: 'Minimumshøjde er {0}.',
  MINIMUM_WIDTH_KEY: 'Minimumsbredde er {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1}(h).',
  MAXIMUM_WIDTH_KEY: 'Maksimumsbredde er {0}',
  MAXIMUM_HEIGHT_KEY: 'Maksimumshøjde er {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Indtast numeriske dimensioner større end nul.',
  PROCESSING_FAILED: 'Behandlingen mislykkedes. Prøv igen efter et stykke tid',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Krypterede PDF-filer understøttes desværre ikke.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importerer {0} af {1}',
  RECOLORING_KEY: 'Omfarvelægger...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE:
    'Denne indholdskilde er beskyttet med en adgangskode',
  AUTHENTICATE_FAILED_MESSAGE: 'Blev ikke godkendt!',
  DROPBOX_IMPORT_ERROR_HEADER: 'Ikke alle filer kunne importeres',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Undskyld, men PDF&apos;er med flere sider er ikke understøttet.',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Vælg din laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Fornavn',
  LAST_NAME_KEY: 'Efternavn',
  PHONE_NUMBER_KEY: 'Telefonnummer',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Ugyldigt telefonnummer',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'Jeg accepterer vilkårene og betingelserne',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Jeg accepterer, at mine personlige oplysninger bliver delt med HP, og at jeg kan blive kontaktet i forbindelse med fremtidige HP-kampagner.*',
  SERVICE_PROVIDER_CONDITION:
    'Jeg accepterer, at de data, jeg angiver, kan blive delt med tjenesteudbydere med henblik på print og levering.*',
  ORDER_DESIGN: 'Bestil design',
  SUBMIT_YOUR_DESIGN: 'Send dit design',
  SUBMISSION_DESIGN_ORDER: 'Indsendelse til designordre',
  ENTER_REQUIRED_FIELDS_KEY: 'Udfyld påkrævede felter',
  ADDRESS_KEY: 'Adresse',
  INVALID_ADDRESS_KEY: 'Ugyldig adresse',
  CITY_KEY: 'By',
  INVALID_CITY_KEY: 'Ugyldig by',
  COUNTRY_KEY: 'Land',
  STATE_KEY: 'Delstat',
  ZIP_KEY: 'Postnummer',
  INVALID_ZIP_KEY: 'Ugyldigt postnummer',
  ORDER_NUMBER: 'Ordrenummer',
  YOUR_DETAILS_KEY: 'Dine detaljer',
  APPLY_DESIGN_COMPETITION: 'Anvend til designkonkurrence',
  NOTICE_KEY: 'Varsel:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'For at have en pc-hud, der er perfekt tilpasset din, skal du vælge den nøjagtige model, der svarer til købet, som det ses på fakturaen.',
  RESTART_PROJECT_ALERT_TITLE: 'Vil du genstarte et projekt?',
  DISCARD_ALERT_MESSAGE: 'Dit aktuelle projekt bliver kasseret',
  RESTART: 'Genstart',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Advarsel om sidestørrelse!',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Denne inspirationskabelon kommer med en standardstørrelse på {0} X {1} {2}. Din sidestørrelse ændres automatisk, så den passer til denne skabelon.',
  MODIFY_SIZE_WARNING:
    'Hvis du ønsker at ændre størrelsen på dette design, kan du gøre det under fanen "Indstillinger". Designelementer kan kræve redigering for at tilpasse dig de ønskede dimensioner.',
  RANDOMIZE_KEY: 'Randomize',
  MATERIAL_CHOICE_APPLIED: 'Materielt valg anvendt.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'certifikat for',
  AUTHENTICITY_STRING: 'autenticitet',
  PLEASE_WAIT: 'Vent',
  PROTECTING_YOUR_DATA: 'beskytter dine data...',
  SEARCH_YOUR_LAPTOP_KEY: 'Søg på din bærbare computer', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Ups! Vi kunne ikke finde nogen bærbare computere til din søgning.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Serienummer',
  LOCKED_PROJECT: 'Låst projekt',
  LOCKED_MESSAGE:
    'Dette projekt er blevet bestilt og kan ikke ændres. Du kan kun vise dette projekt.',
  EXPIRED_PROJECT: 'Udløbet projekt',
  EXPIRED_MESSAGE: 'Dette projekt er udløbet.',
  DELETED_PROJECT: 'Slettet projekt',
  DELETED_MESSAGE: 'Dette projekt er blevet slettet.',
  CHOOSE_GROUP_TYPE: 'Vælg {0}-type',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Indtast tal større end nul.',
  SIZE_KEY: 'Størrelse',
  DISTANCE_FROM_KEY: 'Afstand fra',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Venstre',
  RIGHT_KEY: 'Højre',
  DELETE_WALL_KEY: 'Delete a wall',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'Maksimal vægstørrelse er {0} kvadrat{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'Lærredet er højere end væggen.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'Lærredet er bredere end væggen.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Maksimum antal kolonner for nuværende bredde er {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Maksimum antal rækker for den nuværende højde er {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Væggens bredde er mindre end lærredets bredde.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'Væggen skal have en minimumsbredde på {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Væggen skal have en minimumshøjde på {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Væggens højde er mindre end lærredets højde.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Maksimal væghøjde er {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Rækker',
  COLUMNS_KEY: 'Kolonner',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Rediger',
  TOP_KEY: 'Top',
  BOTTOM_KEY: 'Bund'
};
